var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',{attrs:{"title":"维修管理"}},[_c('div',{staticClass:"infoBox"},[_c('div',_vm._l((_vm.list),function(item){return _c('div',{on:{"click":function($event){return _vm.$router.push(item.router)}}},[_c('img',{attrs:{"src":item.img}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.text))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67664959","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/maintenanceManagement/maintenanceManagement.vue
// module id = null
// module chunks = 